/**
 * Chrome-only ops period label adjacent to hub KPIs (filters often sit below Obnovit).
 * Reuses Mission Control / filter date strings — no new API.
 */
export const HUB_OPS_PERIOD_TEST_ID = 'hub-ops-period';

export interface HubOpsPeriodChromeProps {
  readonly dateFrom: string;
  readonly dateTo: string;
  readonly className?: string;
}

export function HubOpsPeriodChrome({
  dateFrom,
  dateTo,
  className = 'm-0 text-sm tabular-nums text-[var(--color-an-text-muted)]',
}: HubOpsPeriodChromeProps): JSX.Element | null {
  const from = dateFrom.trim();
  const to = dateTo.trim();
  let label = '';
  if (from.length > 0 && to.length > 0) {
    label = `${from} — ${to}`;
  } else if (from.length > 0) {
    label = from;
  } else if (to.length > 0) {
    label = to;
  }
  if (label.length === 0) {
    return null;
  }
  return (
    <p className={className} data-testid={HUB_OPS_PERIOD_TEST_ID}>
      {label}
    </p>
  );
}
